/**
 * Файл с factory константами
 */
import {AppService} from '@app/app.service';
import {IAppServiceLanguages} from '@app/app.interface';
import {AppHelper} from '@app/core/app.helper';
import {InterfaceAccessMatrix} from '@modules/login/interfaces/login.interface';
import {AppSettings} from '@app/core/libraries/Settings/app-settings';
import {IMainLang} from '@interfaces/languages/main-lang';
import {TUI_RUSSIAN_LANGUAGE, TUI_ENGLISH_LANGUAGE} from '@taiga-ui/i18n';
import {of} from 'rxjs';

/** Получение URL API сервера */
export const getServerUrl = (appServer: AppService): string => {
    return appServer.serverUrl;
};

/** Получение словаря с переводами */
export const getDictionary = (appServer: AppService): IMainLang => {
    return appServer?.language_dictionary;
};

/** Получение объекта активных языков системы */
export const getAppLanguages = (appServer: AppService): { [key: string]: IAppServiceLanguages } => {
    return appServer?.languages;
};

/** Получение текущего глобального языка системы */
export const getCurrentLanguage = (appServer: AppService): IAppServiceLanguages => {
    return AppHelper.getCurrentLanguage(appServer);
};

/** Получение объекта с доступами */
export const getAccess = (appServer: AppService): InterfaceAccessMatrix => {
    return appServer?.accessMatrix;
};

/** Получение настроек системы */
export const getSettings = (appServer: AppService): AppSettings => {
    return appServer?.appSettings;
};

export const getCurrentLanguageAlias = (appServer: AppService): string => {
    return AppHelper.getCurrentLanguage(appServer).lang;
};

/** Получение настроек языка для Tui */
export const getTuiLang = () => {
    const lang = window.localStorage.getItem('CurrentLang');
    switch (lang) {
        case 'en':
            return of(TUI_ENGLISH_LANGUAGE);
        default:
            return of(TUI_RUSSIAN_LANGUAGE);
    }
};
